<template>
  <div>
    <div class="header home-header">
      <a v-show="show" href="javascript:void(0)" class="back" @click="goBack"></a>
      <div class="title">
        <slot></slot>
      </div>
      <div v-if="showFlag && loginFlag" class="btn" @click="switchFlag">
        <a href="javascript:void(0)" class="dot" :class="showCircle && isShowDot ? 'new' : ''"></a>
      </div>
      <!-- 隐藏三个点功能时，可以使用其他slot在此位置 -->
      <div class="right-action-wrap"><slot name="action"></slot></div>

      <div v-if="flag" class="toggle_box">
        <img src="../../styles/common/img/toggle_box_top.png" alt="" class="top" />
        <div class="toggle_box_con">
          <a v-if="isHome" href="javascript:void(0)" class="home" @click="navigateTo('/home')"></a>
          <!--        <a v-if="!isHome" href="javascript:void(0)" class="attention" @click="doToogle"></a>-->
          <a v-if="isMine" href="javascript:void(0)" class="mine" :class="showCircle ? 'new' : ''" @click="navigateTo('/myCenter')"></a>
          <a v-if="isCart" href="javascript:void(0)" class="shoppingCart" @click="navigateTo('/shoppingCar')"></a>
          <a v-if="isService" href="javascript:void(0)" class="server" @click="toService"> </a>
        </div>
        <img src="../../styles/common/img/toggle_box_bottom.png" alt="" class="bottom" />
      </div>
    </div>
    <div v-if="!isShow" class="header-seat"></div>
  </div>
</template>

<script>
import store from '../../store';
import { mapGetters } from 'vuex';

export default {
  name: 'FtHeader',
  props: {
    showFlag: {
      default() {
        return {
          default: true
        };
      }
    },
    // props接收是否显示小红点
    isShowDot: {
      default() {
        return true;
      }
    },
    // 是否显示购物车
    isCart: {
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      show: true,
      flag: false,
      isMine: true,
      isHome: true,
      isService: false
    };
  },
  computed: {
    ...mapGetters(['showCircle', 'isShow']),
    loginFlag() {
      if (store.state.app.isLogin) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.$route.path === '/home') {
      this.show = false;
      this.isHome = false;
    } else if (this.$route.path === '/myCenter' || this.$route.path === '/myNews' || this.$route.name === 'topic') {
      this.isMine = false;
    } else if (this.$route.path.indexOf('/entity') > -1 || this.$route.path.indexOf('/order') > -1 || this.$route.path.indexOf('/refund') > -1) {
      this.isService = true;
      this.isMine = false;
    } else {
      this.isHome = true;
    }
    this.initEvent();
  },
  methods: {
    goBack() {
      const path = this.$route.path;
      const pathArr = ['/market', '/paySuccess', '/payFailed'];
      // 指定页面返回时，重定向到首页
      if (pathArr.indexOf(path) !== -1) {
        this.$router.replace('/home');
        return;
      }
      if (this.$listeners.goBack) {
        this.$emit('goBack');
        return;
      }

      this.$router.go(-1);
    },
    switchFlag() {
      this.flag = !this.flag;
    },
    doToogle() {
      this.flag = !this.flag;
      this.$_dialog.toogle();
    },
    navigateTo(path) {
      this.$router.push(path);
    },
    toService() {
      window.FT_UKE_SDK.setIframe('iframeClick');
      this.flag = false;
      document.body.style.overflow = 'hidden';
      // console.log(document.body.style.overflow);
    },
    initEvent() {
      window.addEventListener('message', this.receiveMessage, false);
    },
    receiveMessage(event) {
      // console.log(event.data);
      document.body.style.overflow = 'auto';
      // console.log(document.body.style.overflow);
    }
  }
};
</script>

<style lang="scss" scoped>
.header-seat {
  width: 100%;
  height: 2rem;
}
.home-header {
  position: fixed;
  margin-left: 0;
  top: 0;
  width: 100%;
  z-index: 10;
  max-width: 750px;

  .btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 2rem;
    height: 100%;

    .dot {
      position: absolute;
      width: 1.6rem;
      height: 1rem;
      background: url(img/dot.png) no-repeat center center;
      background-size: 0.9rem 0.2rem;
      right: 0.5rem;
      top: 0.5rem;
    }
  }

  .toggle_box {
    position: absolute;
    width: 4.2rem;
    background: url('img/toggle_box_con.png') no-repeat top center;
    background-size: 100% 100%;
    box-sizing: border-box;
    right: 0.4rem;
    top: 2rem;

    .home {
      display: block;
      background: url('img/home.png') no-repeat center center;
      background-size: 100% auto;
      width: 2.5rem;
      height: 0.625rem;
      margin: 0 auto;
      padding: 0.6rem 0;
    }

    .attention {
      display: block;
      background: url('img/attention.png') no-repeat center center;
      background-size: 100% auto;
      width: 2.5rem;
      height: 0.625rem;
      margin: 0 auto;
      padding: 0.6rem 0;
    }

    .mine {
      display: block;
      background: url('img/mine.png') no-repeat center center;
      background-size: 100% auto;
      width: 2.5rem;
      height: 0.625rem;
      margin: 0 auto;
      padding: 0.6rem 0;
      position: relative;
    }

    .mine.new:before {
      content: '';
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
      background: url('img/new.png') no-repeat top center;
      background-size: 100% 100%;
      top: 0.2rem;
      right: -0.4rem;
      z-index: 1;
    }

    .toggle_box_con a:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
    }

    .top {
      width: 100%;
      display: block;
      position: absolute;
      top: -0.6rem;
      left: 0;
    }

    .bottom {
      width: 100%;
      display: block;
      position: absolute;
      bottom: -0.5rem;
      left: 0;
    }
  }
}

.header .dot.new:before {
  content: '';
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  background: url(img/new.png) no-repeat top center;
  background-size: 100% 100%;
  top: 0;
  right: 0;
  z-index: 1;
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 40%;
  text-align: center;
  margin: 0 auto;
}

.right-action-wrap {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #666666;
  font-size: 0.55rem;
  // 首页
  .home {
    display: inline-block;
    vertical-align: middle;
    width: 2.125rem;
    height: 0.625rem;
  }
  // 设为已读
  .read-btn {
    display: inline-block;
    vertical-align: middle;
    color: #666666;
    i {
      content: '';
      display: inline-block;
      width: 0.725rem;
      height: 0.7rem;
      background: url('img/read.png') no-repeat top center;
      background-size: 100% 100%;
      vertical-align: middle;
      margin-right: 0.125rem;
      margin-top: -0.125rem;
    }
  }
  .shopping_car {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 3.125rem;
    height: 1.1rem;
    img {
      width: 100%;
      height: 100%;
    }
    .cart_num {
      display: inline-block;
      position: absolute;
      top: -0.6rem;
      left: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// header.vue